import { render, staticRenderFns } from "./SectionDowntimes.vue?vue&type=template&id=0b8332f6&"
import script from "./SectionDowntimes.vue?vue&type=script&lang=js&"
export * from "./SectionDowntimes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports